import { getLocaleCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import React from 'react';

import NextImageV2 from '../../../../ui/components/NextImageV2';
import { oms_url } from '../../../config/AppConfig';
import {
  allocationLinkRedirect,
  courierTrackingLinkRedirect,
} from '../helpers/TrackOrderRedirect';
import styles from '../styles/LinkTrackOrders.module.scss';
import { track_order, track_order_live } from '../vm/HeaderStore';
import { right_arrow } from '../vm/HeaderVm';

interface LinkTrackOrdersCmpProps {
  count_of_ongoing_order: number;
  order_crn: string;
  is_courier_order: boolean;
}

function LinkTrackOrdersCmp({
  count_of_ongoing_order,
  order_crn,
  is_courier_order,
}: Readonly<LinkTrackOrdersCmpProps>): React.ReactElement | null {
  const onClickHandler = (): void => {
    if (count_of_ongoing_order > 1) {
      globalThis.location.href = `${oms_url}/${getLocaleCookie()}/order-history`;
    } else if (is_courier_order) {
      courierTrackingLinkRedirect(order_crn);
    } else {
      allocationLinkRedirect(order_crn);
    }
  };

  if (count_of_ongoing_order === 0) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles['track-orders-container']}
      onClick={onClickHandler}
    >
      <div className={styles['text-wrapper']}>
        <p className={styles['text']}>{track_order}</p>
        <div className={styles['live-orders']}>
          <div className={styles['dot']} />
          {track_order_live}
        </div>
      </div>
      <div className={styles['icon']}>
        <NextImageV2
          src={right_arrow.src}
          alt={right_arrow.alt}
          width={right_arrow.width}
          height={right_arrow.height}
        />
      </div>
    </button>
  );
}

export default LinkTrackOrdersCmp;
